var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImgCommentNone = function SvgImgCommentNone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m15.433 61.085.038-11.806L40.75 24.162l11.918 11.696-25.43 25.265-11.805-.038Zm40.072-28.047 6.207-6.166a2 2 0 0 0 .009-2.829l-8.949-9.006a2 2 0 0 0-2.828-.01l-6.356 6.316 11.917 11.695ZM29.47 64.545a2 2 0 0 1-1.416.581l-14.634-.047a2 2 0 0 1-1.994-2.006l.047-14.635a2 2 0 0 1 .59-1.412L47.125 12.19a6 6 0 0 1 8.486.027l8.948 9.007a6 6 0 0 1-.027 8.485l-35.06 34.836Z",
    fill: "#C6C8CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C6C8CC",
    strokeWidth: 4,
    strokeLinecap: "round",
    d: "M44 63h26"
  })));
};
export default SvgImgCommentNone;